const Icons = {
  homeImage: require("../assets/images/homeImg.jpg"),
  logo: require("../assets/images/logo.png"),
  phoneSimulator: require("../assets/images/phoneSimulator.png"),
  zabali: require("../assets/images/zabali.png"),
  finibali_brand_logo: require("../assets/images/finibali_logo_update.png"),
  carat_start_brand_logo: require("../assets/images/carat_start_brand_logo.png"),
  carat_start_brand_logo_updated: require("../assets/images/carat_start_brand_logo_updated.png"),
  soni_jewellers_brand_logo: require("../assets/images/soni_jewellers_brand_logo.png"),
  soni_jewellers_brand_logo_updated: require("../assets/images/soni_jewellers_brand_logo_updated.png"),
  blackHomeImage: require("../assets/images/blackHomeImg.png"),
  aboutUs: require("../assets/images/about.png"),
  aboutusImg: require("../assets/images/aboutus_img.jpg"),
  aboutus_banner_img: require("../assets/images/aboutus_banner_img.jpg"),
  contactImg: require("../assets/images/contact_banner_img_check.jpg"),
  teamMembers: require("../assets/images/team.png"),
  team2Members: require("../assets/images/team2.png"),
  team3Members: require("../assets/images/team3.png"),
  team4Members: require("../assets/images/team4.png"),
  career: require("../assets/images/career.png"),

  project: require("../assets/images/project.png"),
  enviournment: require("../assets/images/enviournment.png"),
  oppournities: require("../assets/images/opportunities.png"),
  salary: require("../assets/images/salary.png"),


  mobileIcon: require("../assets/icons/mobile.png"),
  graphicsIcon: require("../assets/icons/graphics.png"),
  webIcon: require("../assets/icons/web.png"),

  expertiseIcon: require("../assets/icons/expertise.png"),
  clientIcon: require("../assets/icons/client.png"),
  scalableIcon: require("../assets/icons/scalable.png"),
  deadlineIcon: require("../assets/icons/deadlines.png"),


  facebookIcon: require("../assets/icons/facebook.png"),
  instagramIcon: require("../assets/icons/instagram.png"),
  whatsappIcon: require("../assets/icons/whatsapp_ico.webp"),
  linkedInIcon: require("../assets/icons/linkedin.png"),

  creativeIcon: require("../assets/icons/creative.png"),
  solutionIcon: require("../assets/icons/solutions.png"),
  customerIcon: require("../assets/icons/customer.png"),
  staticsIcon: require("../assets/icons/statics.png"),
  verifiedIcon: require("../assets/icons/verified.png"),
  closeIcon: require("../assets/icons/close.png"),
  trustedBrandLogo: require("../assets/icons/trusted_brand_logo.webp"),
  VKJewels: require("../assets/icons/VK_jewels.webp"),
  mobile_tab_image: require("../assets/images/mobile_tab_image.jpg"),
  mobile_tab_image_2: require("../assets/images/mobile_tab_image_2.jpg"),
  mission_vision_img: require("../assets/images/mission_vision_img.jpg"),
  why_bacode_img: require("../assets/images/why_bacode_img.jpg"),

};

export default Icons;
